export const NO_TRADING = 'NO_TRADING';
export const PRE_MARKET = 'PRE_MARKET';
export const REGULAR = 'REGULAR';
export const AFTER_MARKET = 'AFTER_MARKET';
